export const getMatch = (match: string, text?: string) => {
  if (!text) return ''

  const begin = text.toLowerCase().indexOf(match.toLowerCase())
  const end = match.length + begin

  return begin >= 0 && match.length ? text.substring(begin, end) : ''
}

type HighlightVariant = 'bold' | 'mark'

export const highlightMatch = (
  text: string,
  match: string,
  variant: HighlightVariant = 'bold'
) => {
  const highlightTag: Record<HighlightVariant, string> = {
    bold: 'b',
    mark: 'mark',
  }

  if (!text) return ''

  const originalMatch = getMatch(match, text)

  if (!originalMatch) return text

  const tag = highlightTag[variant]
  return `${text.replace(originalMatch, `<${tag}>${originalMatch}</${tag}>`)}`
}
